import { render, staticRenderFns } from "./NotAuthorized.vue?vue&type=template&id=540234fa&scoped=true"
import script from "./NotAuthorized.vue?vue&type=script&lang=js"
export * from "./NotAuthorized.vue?vue&type=script&lang=js"
import style0 from "./NotAuthorized.vue?vue&type=style&index=0&id=540234fa&prod&lang=scss"
import style1 from "./NotAuthorized.vue?vue&type=style&index=1&id=540234fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540234fa",
  null
  
)

export default component.exports